export default "__VITE_ASSET__DdzOprev__"